import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

const AboutCard = () => {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am <span className="purple">Wafula Colin Lubembe </span>
            from <span className="purple"> Kampala, Uganda.</span>
            <br />
            I am currently employed as a software developer at Nova Generation.
            <br />
            <br />
            I specialize in full-stack web development, with a strong focus on
            creating efficient and scalable web applications. My expertise
            includes working with technologies such as React, Node.js, Python,
            and various databases like MongoDB and PostgreSQL.
            <br />
            <br />
            I am passionate about leveraging technology to solve real-world
            problems and continuously improving my skills through learning and
            practical experience. I am always open to new opportunities and
            collaborations, so feel free to connect with me!
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Anime
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Books
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
};

export default AboutCard;
